module.exports = __webpack_public_path__ + "assets/img/placeholder/next-300x169.jpg";